var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('div', {
    staticClass: "container container-profile"
  }, [_c('b-card', {
    staticClass: "p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('profile-form', {
    staticClass: "mb-4",
    attrs: {
      "error": _vm.profileError,
      "profile-response": _vm.getProfile
    },
    on: {
      "submit": _vm.onSubmitProfile
    }
  })], 1), _c('b-card', {
    staticClass: "p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('password-form', {
    attrs: {
      "error": _vm.passwordError
    },
    on: {
      "submit": _vm.onSubmitPassword
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }